import React from 'react';
import './load.css';

export const Load = () => {
    return (
        <div id="preloader">
            <div className="loader"></div>
        </div>
    )
}
